// export const requestUrl = 'http://192.168.1.16:5000/api/v1'


//线上
export const orgId = 66
export const requestUrl ='http://www.hrnygs.com:4000/api/v1'
// export const requestUrl = 'http://localhost:5000/api/v1'

// export const requestUrl = 'http://192.168.1.19:5000/api/v1'
// export const baseUrl = 'http://192.168.1.16'
//测试1
// export const orgId = 61
// export const requestUrl = 'http://192.168.1.16:5000/api/v1'


// 测试2
// export const orgId = 61
// export const requestUrl = 'http://localhost:5000/api/v1'
//
// export const baseUrl = 'http://192.168.1.16:8083'



// WEBPACK FOOTER //
// ./src/common/cons.js